export default __webpack_public_path__ + "static/media/deathvalley.1426adb5.jpg";